import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import * as S from './Header.styles';

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleNavLinkClick = (sectionId: string) => {
    setIsMenuOpen(false);
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <S.HeaderContainer $isScrolled={isScrolled}>
      <S.HeaderContent $isScrolled={isScrolled}>
        <S.Logo>
          <S.LogoText $isScrolled={isScrolled}>Dra. Suni Wiphala</S.LogoText>
          <S.LogoSubtext $isScrolled={isScrolled}>Medicina Integral</S.LogoSubtext>
        </S.Logo>

        <S.Nav $isMenuOpen={isMenuOpen}>
          <S.NavLink onClick={() => handleNavLinkClick('inicio')}>
            Inicio
          </S.NavLink>
          <S.NavLink onClick={() => handleNavLinkClick('sobre-mi')}>
            Sobre Mí
          </S.NavLink>
          <S.NavLink onClick={() => handleNavLinkClick('servicios')}>
            Servicios
          </S.NavLink>
          <S.NavLink onClick={() => handleNavLinkClick('contacto')}>
            Contacto
          </S.NavLink>
        </S.Nav>

        <S.MobileMenuButton onClick={handleMenuToggle}>
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </S.MobileMenuButton>
      </S.HeaderContent>
    </S.HeaderContainer>
  );
};

export default Header;